import styled from 'styled-components';
import { useController } from 'react-hook-form';

export const PillsSelector = ({
  name,
  control,
  options,
  required = false,
  maxSelections = null,
}) => {
  const { field } = useController({
    name,
    control,
    rules: { required: required ? `${name} is required` : false },
    defaultValue: [],
  });

  const selectedValues = Array.isArray(field.value) ? field.value : [];

  const toggleSelection = (value) => {
    const newSelection = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : maxSelections && selectedValues.length >= maxSelections
      ? selectedValues
      : [...selectedValues, value];

    field.onChange(newSelection);
  };

  return (
    <div>
      <PillsContainer>
        {options.map((option) => (
          <Pill
            key={option.value}
            type="button"
            selected={selectedValues.includes(option.value)}
            onClick={() => toggleSelection(option.value)}
          >
            {option.label}
          </Pill>
        ))}
      </PillsContainer>
    </div>
  );
};

const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  align-items: flex-start;
  margin-bottom: 1.6rem;
`;

const Pill = styled.button`
  all: unset;
  display: inline-flex;
  align-items: center;
  padding: 0.6rem 0.8rem;
  border-radius: 0.4rem;
  border: ${(props) =>
    props.selected
      ? '1px solid var(--color-secondary)'
      : '1px dashed var(--color-grayscale-manatee)'};
  background: ${(props) => (props.selected ? '#3670ff33' : 'transparent')};
  color: ${(props) => (props.selected ? '#fafafa' : 'var(--color-grayscale-manatee)')};
  font-size: 1.2rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 2.4rem;
  box-sizing: border-box;

  &:hover {
    background: ${(props) => (props.selected ? '#3670ff50' : '#2d2f35')};
  }
`;
